import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DragulaModule } from 'ng2-dragula';

import { AlertModule } from '@shared/modules/alert';
import { CbProgressModule } from './../cb-progress';

import { CbDataTableComponent } from './cb-data-table.component';

@NgModule({
  declarations: [
    CbDataTableComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    TranslateModule,
    AlertModule,
    CbProgressModule,
    DragulaModule
  ],
  exports: [
    CbDataTableComponent
  ]
})
export class CbDataTableModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: CbDataTableModule,
      providers: []
    };
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/cb-data-table/cb-data-table.module.ts